import Entity from "./entity";
export default class Ticket extends Entity<number> {
  ticketImages: Array<any>;
  name: string;
  flow: string;
  displayOrder: Number;
  showOnHome: boolean;
  price: number;
  description: string;
  useRole: string;
  endTime: string;
  regionId: number;
  startTime: string;
  supplierId: number;
  courtId: number | null = 0;
  remark:string="";
  //    type: number;
}
